import { render, staticRenderFns } from "./RoomProfiles.vue?vue&type=template&id=783e8921&"
import script from "./RoomProfiles.vue?vue&type=script&lang=js&"
export * from "./RoomProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports